var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('VMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }